import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 10,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '200%',
    gap: 5,
    paddingBottom: '3px',
    borderBottom: '1px solid black',
    paddingTop: '150px',
    paddingRight: '40px',
    paddingLeft: '150px',
    position: "relative",
  },
  contentContainer3: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderTop: '1px solid black'
  },
  column: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    marginLeft: "7%"
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 2,
    width: "100%"
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10,
    width: '40%'
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '60%'
  },
  bottomLine: {
    width: '200%',
    borderTop: '1px solid black',
    marginTop: 260,
    marginLeft: '165px',
    marginRight: '90px',
    position: 'relative',
    top: -10
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf21 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const istParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).formatToParts(date);
    const day = istParts.find((p) => p.type === 'day').value;
    const month = istParts.find((p) => p.type === 'month').value;
    const year = istParts.find((p) => p.type === 'year').value;
    return `${day}/${month}/${year}`;
  }

  function formatDateTime(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    
    return `${day}-${month}-${year}  ${formattedHours}:${minutes} ${ampm}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  function calculateValidUpto(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    date.setDate(date.getDate() + 7);
    return formatDate(date);
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <PDFImage src="/PDf Print Format.png" style={{ width: '100%', height: '100%' }} />
          </Page>
          <View style={styles.contentContainer}>
            {/* Left Column */}
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="OPD No." style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={data.op_no}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Patient Name" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={data.name}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Department" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={data.department}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Address" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={data.address}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Mobile No." style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={data.mobile}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
            </View>

            {/* Right Column */}
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Date" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={`${formatDateTime(data.reg_date)}`}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Age / Sex" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={`${data.age}    ${data.gender}`}
                  style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                />
              </View>
              <View style={styles.row}>
                <Text content="UHID NO." style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={`${data.uhid}`}
                  style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Valid Upto" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={`${calculateValidUpto(data.reg_date)}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Consultant" style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content=": " style={{ ...styles.label, fontFamily: 'Roboto', width: '5%' }} />
                <Text
                  content={`${data.consultant}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View>
            </View>
          </View>
           <View style={styles.bottomLine} />
        </Document>
      </PDFViewer>
    </div>
  );
};